const styles = {
  dropDownIcon: {
    marginRight: '-8px',
    height: '35px',
    width: '35px'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/SubcategorySelector/defaultStyles.js